/* eslint-disable import/no-duplicates */
import React, {
  useEffect,
  useRef,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import { FaFileDownload } from 'react-icons/fa';
import api from '../../../services/api';

import { TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import SelectSync, { IOption } from '../../../components/SelectSync';
import Loading from '../../../components/Loading';

import getValidationErrors from '../../../utils/getValidationErrors';

import getResponseErrors from '../../../utils/getResponseErrors';
import PageInfo from '../../../components/PageInfo';
import HeaderRelatorio from '../HeaderRelatorio';
import { usePerfil } from '../../../hooks/perfil';

interface IRelatorio {
  Total: number;
  Nome: string;
  Qtd: number;
  Procedimento?: string;
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  CliCodigo: string;
  PerCodigo: string;
  agrupar: string;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

const Encaminhamentos: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user } = useAuth();
  const { optionsClinica } = useClinica();

  const { optionsPerfil, buscaPerfil } = usePerfil();
  // const { optionsMedico, buscaOptionsMedico } = useMedico();

  const [optionPerfil, setOptionsPerfil] = useState<IOption[]>([]);

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorio[]>();

  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    CliCodigo: user.UsuClinica.toString(),
    agrupar: 'MedNome',
  };
  const [dataExibe, setDataExibe] = useState<IDataExibe>();
  const [clinica, setClinica] = useState('');

  const informacoesPagina = `<b>Descrição:</b> Exibe total de encaminhamentos realizados.`;

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  // useEffect(() => {
  //   async function loadMedicos(): Promise<void> {
  //     await buscaOptionsMedico();
  //   }
  //   if (!optionsMedico || Object.keys(optionsMedico).length === 0)
  //     loadMedicos();
  // }, [buscaOptionsMedico, optionsMedico]);

  useEffect(() => {
    try {
      setOptionsPerfil(optionsPerfil.optionPerfis);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfis',
        type: 'error',
      });
    }
  }, [addToast, optionsPerfil]);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const totais = useMemo(() => {
    if (dadosRelatorio?.length === 0) return { qtdTotal: 0, valorTotal: 0 };

    const qtdTotal = dadosRelatorio?.reduce((tot, item) => {
      return tot + Number(item.Qtd);
    }, 0);

    const valorTotal = dadosRelatorio?.reduce((tot, item) => {
      return tot + Number(item.Total);
    }, 0);

    return { qtdTotal, valorTotal };
  }, [dadosRelatorio]);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        const schema = Yup.object().shape({
          dataInicio: Yup.date().required(),
          dataFim: Yup.date().required(),
          CliCodigo: Yup.string().required(),
          PerCodigo: Yup.string().nullable(true),
          agrupar: Yup.string().required(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        setClinica(
          optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label ||
            '',
        );

        const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
        const dataFimSelecionada = parseISO(dados.dataFim.toString());

        const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
        const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');

        setDataExibe({
          dataDiaSemana: `${format(
            dataInicioSelecionada,
            'dd/MM/yyyy',
          )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`,
          dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
        });

        let parametrosOpcionais = `&agrupar=${dados.agrupar}`;

        parametrosOpcionais += dados.PerCodigo
          ? `&PerCodigo=${dados.PerCodigo}`
          : '';

        const response = await api.get<IRelatorio[]>(
          `/relatorios/encaminhamentos?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&CliCodigo=${dados.CliCodigo}${parametrosOpcionais}`,
        );

        // const dadosFormatados = response.data.map(rel => {
        //   return {
        //     ...rel,
        //     AgeInicioFormatado: format(
        //       parseISO(rel.AgeInicio.toString()),
        //       'dd/MM/yyyy',
        //     ),
        //   };
        // });

        // const ordenado = arrayGroupBy(dadosFormatados, i => i.ConNome);

        // const ordenadoFormatado = ordenado.map(ord => {
        //   return {
        //     grupo: ord[0].ConNome,
        //     totalRegistros: ord.length,
        //     dados: ord,
        //   };
        // });

        setDadosRelatorio(response.data);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, optionsClinica],
  );

  const handleDownload = useCallback(async () => {
    setLoading(true);
    try {
      const dados = {
        dataInicio: formRefBusca.current?.getFieldValue('dataInicio'),
        dataFim: formRefBusca.current?.getFieldValue('dataFim'),
        CliCodigo: formRefBusca.current?.getFieldValue('CliCodigo'),
        PerCodigo: formRefBusca.current?.getFieldValue('PerCodigo'),
        agrupar: formRefBusca.current?.getFieldValue('agrupar'),
      };

      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        dataInicio: Yup.date().required(),
        dataFim: Yup.date().required(),
        CliCodigo: Yup.string().required(),
        PerCodigo: Yup.string().nullable(true),
        agrupar: Yup.string().required(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });

      setClinica(
        optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label || '',
      );

      const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
      const dataFimSelecionada = parseISO(dados.dataFim.toString());

      const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
      const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');

      setDataExibe({
        dataDiaSemana: `${format(
          dataInicioSelecionada,
          'dd/MM/yyyy',
        )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`,
        dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
      });

      let parametrosOpcionais = `&agrupar=${dados.agrupar}`;

      parametrosOpcionais += dados.PerCodigo
        ? `&PerCodigo=${dados.PerCodigo}`
        : '';

      const response = await api.get(
        `/relatorios/encaminhamentosexport?dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&CliCodigo=${dados.CliCodigo}${parametrosOpcionais}`,
      );

      const link = document.createElement('a');
      link.href = response.data.url;
      link.setAttribute(
        'download',
        `procedimentoValor${Math.floor(Date.now() / 1000)}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, optionsClinica]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Encaminhamentos</h2>
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.ATENDENTE_CAIXA}
            />
          </div>
          {optionsClinica.length > 0 && user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={2}>
                  <Input name="dataInicio" label="De" type="date" required />
                </Col>
                <Col md={2}>
                  <Input name="dataFim" label="Até" type="date" required />
                </Col>
                <Col md={2}>
                  <SelectSync
                    name="PerCodigo"
                    label="Perfil"
                    options={optionPerfil}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={2}>
                  <SelectSync
                    name="agrupar"
                    label="Agrupar por"
                    options={[
                      { value: 'MedNome', label: 'MÉDICO' },
                      { value: 'UnsNome', label: 'UNIDADE DE SAÚDE' },
                    ]}
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={2}>
                  <Select
                    name="CliCodigo"
                    label="Clinica"
                    options={optionsClinica}
                    disabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                  />
                </Col>
                <Col md={1}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
                <Col md={1}>
                  <br />
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-success"
                    disabled={!dadosRelatorio}
                    onClick={() => handleDownload()}
                  >
                    <FaFileDownload />
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>

        <HeaderRelatorio
          dataImpressao={dataExibe?.dataHora}
          titulo={`ENCAMINHAMENTOS ${
            clinica.length > 0 ? `- ${clinica} -` : '-'
          } ${dataExibe?.dataDiaSemana || ''}`}
        />

        <div className="bg-white border p-2">
          {dadosRelatorio && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th>Nome</th>
                    <th>Qtd</th>
                    <th>Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.map(rel => (
                      <tr
                        key={`rel-${rel.Nome}-${rel.Total.toString()}`}
                        data-id={rel.Nome}
                        style={{ fontSize: '.7rem', height: '30px' }}
                      >
                        <td>{rel.Nome}</td>
                        <td style={{ textAlign: 'right' }}>{rel.Qtd}</td>
                        <td style={{ textAlign: 'right' }}>{rel.Total}</td>
                      </tr>
                    ))}
                  {totais.qtdTotal && totais.qtdTotal > 0 && (
                    <tr
                      key="rel-total"
                      data-id="Total"
                      style={{ fontSize: '.7rem', height: '30px' }}
                    >
                      <td style={{ textAlign: 'right' }}>
                        <b>Total</b>
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <b>{totais.qtdTotal}</b>
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <b>{totais.valorTotal}</b>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default Encaminhamentos;
